// PasswordResetForm.js
// Public user password reset form for job portal



import React, { useState, useEffect } from 'react';
import { requestPublicUserPasswordReset } from '../api/api';
import './PasswordResetForm.css';


const PasswordResetForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Listen for dark mode changes from Navbar
  useEffect(() => {
    const updateThemeClass = () => {
      if (document.body.classList.contains('dark-mode')) {
        document.body.classList.add('dark');
        document.body.classList.remove('light');
      } else {
        document.body.classList.add('light');
        document.body.classList.remove('dark');
      }
    };
    updateThemeClass();
    window.addEventListener('darkModeChanged', updateThemeClass);
    return () => window.removeEventListener('darkModeChanged', updateThemeClass);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      await requestPublicUserPasswordReset(email);
      setMessage('If this email exists, a reset link has been sent.');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset link');
    }
  };

  return (
    <div className="password-reset-form-container">
      <div className="password-reset-card">
        <div className="password-reset-title">Reset Password</div>
        <div className="password-reset-desc">
          Enter your email address and we'll send you a link to reset your password.
        </div>
        <form className="password-reset-form" onSubmit={handleSubmit} autoComplete="off">
          <label className="password-reset-label" htmlFor="reset-email">Email Address</label>
          <input
            className="password-reset-input"
            id="reset-email"
            name="email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
          <button className="password-reset-btn" type="submit">Send Reset Link</button>
        </form>
        {error && <div className="password-reset-message error">{error}</div>}
        {message && <div className="password-reset-message success">{message}</div>}
      </div>
    </div>
  );
};

export default PasswordResetForm;
